/**
 * OAuth callback page. Calls completeRedirectLogin on mount and shows an error when sign-in fails.
 */

import Box from "@cloudscape-design/components/box"
import SpaceBetween from "@cloudscape-design/components/space-between"
import Spinner from "@cloudscape-design/components/spinner"
import { useEffect, useRef } from "react"
import { CenteredPage, SignInMessage } from "../../components/SignInMessage/SignInMessage"
import { useAuth } from "../../contexts/AuthContext"

const AuthCallback = () => {
  const { redirectError, completeRedirectLogin } = useAuth()

  // Complete sign-in once; the ref guards against StrictMode's double-invoke and re-renders.
  const exchangeStarted = useRef(false)
  useEffect(() => {
    if (exchangeStarted.current) return
    exchangeStarted.current = true
    void completeRedirectLogin()
  }, [completeRedirectLogin])

  if (redirectError) {
    return (
      <SignInMessage
        header="Sign-in did not complete"
        body="We could not finish signing you in. Please try again, or contact your administrator if the problem continues."
      />
    )
  }

  return (
    <CenteredPage>
      <Box textAlign="center">
        <SpaceBetween size="l" direction="vertical" alignItems="center">
          <Spinner size="large" />
          <Box variant="p">Signing you in...</Box>
        </SpaceBetween>
      </Box>
    </CenteredPage>
  )
}

export default AuthCallback
